import type {
  PublicHydratedEntityTemplate,
  TemplatableEntity,
} from './entity-templates';
import type { ListViewPage, SortDirection } from './listViewTypes';
import type { Task } from './taskTypes';

export interface ListedTask extends Task {}

export enum SortBy {
  NAME = 'name',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}

export type GetListedTemplatesQueryParams = {
  pageNumber: number;
  pageSize: number;
  sortBy: SortBy;
  sortDirection: SortDirection;
  searchTerm?: string;
  includeServicePlanTemplates?: boolean;
  entityTypes?: TemplatableEntity[];
};

export type ListedTemplatesPage = ListViewPage<
  PublicHydratedEntityTemplate<'task' | 'scheduledEvent'>
>;
